import script from "./SButtonToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./SButtonToggle.vue?vue&type=script&setup=true&lang=js"

import "./SButtonToggle.vue?vue&type=style&index=0&id=283f25f4&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283f25f4"]])

export default __exports__